import { render } from "./AgentExtensionReportSort.vue?vue&type=template&id=70f3ade8&ts=true"
import script from "./AgentExtensionReportSort.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentExtensionReportSort.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/agent-extension/components/AgentExtensionReportSort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70f3ade8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70f3ade8', __exports__)) {
    api.reload('70f3ade8', __exports__)
  }
  
  module.hot.accept("./AgentExtensionReportSort.vue?vue&type=template&id=70f3ade8&ts=true", () => {
    api.rerender('70f3ade8', render)
  })

}


export default __exports__